import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

/** Matches the read-only view of TaskDetail: details card, comments card, activity card. */
export function TaskDetailSkeleton() {
  return (
    <div className="space-y-8" role="status" aria-label="Loading task">
      {/* ── Task Details ── */}
      <div className="space-y-3">
        <Skeleton className="h-7 w-32 rounded" />
        <Card variant="elevated">
          <CardContent className="pt-8 pb-8 px-6 lg:px-8">
            <div className="space-y-5">
              {/* Status */}
              <div className="space-y-1.5">
                <Skeleton className="h-4 w-12 rounded" />
                <Skeleton className="h-[39px] w-full rounded-lg" />
              </div>
              {/* Action */}
              <div className="space-y-1.5">
                <Skeleton className="h-4 w-14 rounded" />
                <Skeleton className="h-[39px] w-full rounded-lg" />
              </div>
              {/* Assignee */}
              <div className="space-y-1.5">
                <Skeleton className="h-4 w-18 rounded" />
                <Skeleton className="h-[39px] w-full rounded-lg" />
              </div>
              {/* Acceptance Criteria */}
              <div className="space-y-1.5">
                <Skeleton className="h-4 w-14 rounded" />
                <Skeleton className="h-[80px] w-full rounded-lg" />
              </div>
              {/* Notes */}
              <div className="space-y-1.5">
                <Skeleton className="h-4 w-36 rounded" />
                <Skeleton className="h-[80px] w-full rounded-lg" />
              </div>
              {/* Deadline + Priority grid */}
              <div className="grid grid-cols-2 gap-5 max-sm:grid-cols-1">
                <div className="space-y-1.5">
                  <Skeleton className="h-4 w-16 rounded" />
                  <Skeleton className="h-[39px] w-full rounded-lg" />
                </div>
                <div className="space-y-1.5">
                  <Skeleton className="h-4 w-14 rounded" />
                  <Skeleton className="h-[39px] w-full rounded-lg" />
                </div>
              </div>
              {/* Source */}
              <div className="space-y-1.5">
                <Skeleton className="h-4 w-14 rounded" />
                <Skeleton className="h-[39px] w-full rounded-lg" />
              </div>
              {/* Edit button */}
              <div className="flex justify-center pt-2">
                <Skeleton className="h-10 w-28 rounded-md" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* ── Comments ── */}
      <div className="space-y-3">
        <Skeleton className="h-7 w-48 rounded" />
        <Card variant="elevated">
          <CardContent className="pt-8 pb-8 px-6 lg:px-8">
            <div className="space-y-4">
              <Skeleton className="h-20 w-full rounded-lg" />
              <Skeleton className="h-10 w-32 rounded-md" />
            </div>
          </CardContent>
        </Card>
      </div>

      {/* ── Activity History ── */}
      <div className="space-y-3">
        <Skeleton className="h-7 w-36 rounded" />
        <Card variant="elevated">
          <CardContent className="pt-8 pb-8 px-6 lg:px-8">
            <div className="space-y-4">
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="flex items-start gap-3">
                  <Skeleton className="h-8 w-8 rounded-full shrink-0" />
                  <div className="space-y-1.5 flex-1">
                    <Skeleton className="h-4 w-48 rounded" />
                    <Skeleton className="h-3 w-24 rounded" />
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
